// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fiat-withdraw-widget {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.fiat-withdraw-step-label {
  font-size: 20px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 0px;
}

.fiat-withdraw-help {
  font-size: 15px;
  color: #9CA3AF;
  margin: 0 0 8px;
  line-height: 1.5;
}

.fiat-withdraw-help--error {
  color: #e45561;
  font-weight: 600;
}

.wf-preview {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 8px;
}

.wf-preview-row {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  font-size: 15px;
  color: #9CA3AF;
}

.wf-preview-row strong {
  color: #fff;
  font-weight: 600;
}

.wf-preview-row--net strong {
  color: #D1AA67;
}

.wf-preview-hint {
  margin: 8px 0 0;
  font-size: 12px;
  line-height: 1.45;
  color: #848E9C;
}

.wf-verify-preview {
  margin: 0 0 16px;
}

.wf-history-cancel-btn {
  display: inline-flex;
  margin-top: 8px;
  min-height: 32px;
  padding: 4px 12px;
  border-radius: 999px;
  border: 1px solid #fca5a5;
  background: transparent;
  color: #fca5a5;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}

.wf-history-cancel-btn:hover:not(:disabled) {
  background: rgba(252, 165, 165, 0.12);
}

.wf-history-cancel-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}


.wf-history-grid.df-deposit-history-head,
.wf-history-grid.df-deposit-history-row {
  grid-template-columns: 1.15fr 0.85fr 0.65fr 0.55fr 1.15fr 0.9fr 0.75fr;
  min-width: 1040px;
}

.df-deposit-history-desktop--fiat.df-deposit-history-desktop--withdraw .df-deposit-history-head,
.df-deposit-history-desktop--fiat.df-deposit-history-desktop--withdraw .df-deposit-history-row {
  grid-template-columns: 1.15fr 0.8fr 0.6fr 0.5fr 1.1fr 0.85fr 1.15fr;
  min-width: 1080px;
}

.df-deposit-history-desktop--withdraw .df-deposit-history-row-cell--action {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
}

.wf-history-review-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 32px;
  padding: 4px 14px;
  border-radius: 999px;
  border: 1px solid #d1aa67;
  background: transparent;
  color: #d1aa67;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}

.wf-cancel-confirm-actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 12px;
}

.wf-cancel-confirm-keep,
.wf-cancel-confirm-yes {
  min-width: 160px;
  height: 46px;
  border-radius: 999px;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
}

.wf-cancel-confirm-keep {
  border: 1px solid #2b3139;
  background: transparent;
  color: #eaecef;
}

.wf-cancel-confirm-keep:hover:not(:disabled) {
  border-color: #d1aa67;
  color: #d1aa67;
}

.wf-cancel-confirm-yes {
  border: none;
  background: #d1aa67;
  color: #0c0d10;
}

.wf-cancel-confirm-yes:hover:not(:disabled) {
  background: #c49a55;
}

.withdraw_hist_detail_modal.wf-fiat-detail-modal {
  max-height: none;
  overflow: visible;
  padding: 18px 22px 16px;
  width: 520px;
}

.wf-fiat-detail-modal .withdraw_hist_stepper {
  margin-top: 12px;
}

.wf-fiat-detail-modal .withdraw_hist_step_note {
  margin-top: 2px;
  margin-bottom: 0;
}

.wf-fiat-detail-modal .withdraw_hist_rows {
  margin-top: 12px;
  padding-top: 10px;
  gap: 8px;
}

.wf-fiat-detail-modal .withdraw_hist_row {
  padding: 0;
  min-height: 0;
}

.wf-fiat-detail-modal .withdraw_hist_row_label,
.wf-fiat-detail-modal .withdraw_hist_row_value {
  font-size: 13px;
  line-height: 1.35;
}

.wf-fiat-detail-cancel {
  width: 100%;
  margin-top: 14px;
}

.wf-fiat-detail-help {
  margin-top: 10px;
  padding-left: 0;
  text-align: center;
  align-items: center;
}

body.light_theme .wf-cancel-confirm-keep {
  border-color: #eaecef;
  color: #1e2329;
}

.df-deposit-history-desktop--withdraw .wf-history-cancel-btn,
.wf-history-mobile-actions .wf-history-cancel-btn {
  margin-top: 0;
}

.wf-history-mobile-actions {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.wf-history-pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 18px 0 6px;
}

.wf-history-page-btn {
  min-width: 92px;
  padding: 8px 14px;
  border-radius: 999px;
  border: 1px solid #2B3139;
  background: #181A20;
  color: #EAECEF;
  font-size: 13px;
  cursor: pointer;
}

.wf-history-page-btn:hover:not(:disabled) {
  border-color: #D1AA67;
  color: #D1AA67;
}

.wf-history-page-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.wf-history-page-info {
  font-size: 13px;
  color: #848E9C;
}

body.light_theme .wf-history-page-btn {
  background: #fff;
  border-color: #EAECEF;
  color: #1E2329;
}

.fiat-withdraw-limit {
  font-size: 14px;
  color: #9CA3AF;
  padding-top: 6px;
  text-align: right;
}

.fiat-withdraw-limit--error {
  color: #e45561;
  font-weight: 600;
}

.fiat-withdraw-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 5px;
}

.fiat-withdraw-field label {
  font-size: 14px;
  font-weight: 500;
  color: #9CA3AF;
  margin-bottom: 5px;
  display: block;
}

.fiat-withdraw-field-hint {
  margin: 6px 0 0;
  font-size: 13.65px;
  line-height: 1.45;
  color: #9CA3AF;
}

body.light_theme .fiat-withdraw-step-label {
  color: #222222;
}

.fiat-withdraw-field input,
.fiat-withdraw-field select {
  width: 100%;
  color: #fff;
  font-weight: 600;
  font-size: 15px;
  background: rgb(255 255 255 / 5%);
  border: 1px solid #5c5c5c;
  border-radius: 50px;
  padding: 16px 20px;
}

.fiat-withdraw-field input:focus {
  outline: none;
  border-color: #D1AA67;
}

.fiat-withdraw-field input::placeholder {
  color: #707A8A;
}

.fiat-withdraw-otp-row {
  display: flex;
  gap: 10px;
  align-items: center;
  flex-wrap: wrap;
}

.fiat-withdraw-otp-row input {
  flex: 1 1;
  min-width: 140px;
  letter-spacing: 4px;
  text-align: center;
  font-size: 18px;
}

.fiat-withdraw-resend {
  background: none;
  border: none;
  color: #D1AA67;
  font-size: 13px;
  cursor: pointer;
  padding: 0;
}

.fiat-withdraw-resend:disabled {
  color: #707A8A;
  cursor: not-allowed;
}

.fiat-withdraw-bank-card {
  position: relative;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  /* border: 1px solid #2B3139; */
  border-radius: 14px;
  padding: 18px;
  margin-bottom: 10px;
  cursor: pointer;
  transition: 0.2s;
  background: rgb(255 255 255 / 10%);
}

.fiat-withdraw-bank-card--static {
  cursor: default;
}

/* .fiat-withdraw-bank-card:hover,
.fiat-withdraw-bank-card.selected {
  border-color: #D1AA67;
} */

.wf-account-radio-input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.wf-account-radio {
  flex-shrink: 0;
  width: 44px;
  min-width: 44px;
  height: 44px;
  margin-top: 2px;
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, 0.15);
  box-sizing: border-box;
  background: rgba(255, 255, 255, 0.03);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  transition: all 0.2s ease;
}

.wf-account-radio::before {
  content: "";
  position: absolute;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 2px solid #5E6673;
  box-sizing: border-box;
  transition: all 0.2s ease;
}

.wf-account-radio::after {
  content: "";
  position: absolute;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: transparent;
  transition: all 0.2s ease;
}

.fiat-withdraw-bank-card.selected .wf-account-radio {
  border-color: rgba(209, 170, 103, 0.35);
  background: rgba(209, 170, 103, 0.08);
}

.fiat-withdraw-bank-card.selected .wf-account-radio::before {
  border-color: #D1AA67;
}

.fiat-withdraw-bank-card.selected .wf-account-radio::after {
  background: #D1AA67;
}

button.fiat-withdraw-btn.adbankbtn {
  background: rgb(0 0 0 / 10%);
  color: #fff;
  text-decoration: none;
  min-height: 52px;
  border-radius: 50px;
}

.fiat-withdraw-field.verificationcode_block .fiat-withdraw-otp-row {
  background: rgba(0, 0, 0, 0.10);
  border: 1px solid #5c5c5c;
  border-radius: 50px;
  padding-right: 20px;
}

.fiat-withdraw-field.verificationcode_block .fiat-withdraw-otp-row input {
  background: none;
  border: none;
  text-align: left;
}

body.light_theme .fiat-withdraw-field.verificationcode_block .fiat-withdraw-otp-row {
  background: rgb(0 0 0 / 5%);
  border: 1px solid #e8e8e8;
}

.fiat-withdraw-bank-card__body {
  flex: 1 1;
  min-width: 0;
}

.fiat-withdraw-bank-card__top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
}

.fiat-withdraw-bank-card__name {
  font-size: 15px;
  font-weight: 700;
  color: #fff;
}

.fiat-withdraw-bank-card__meta {
  font-size: 14px;
  color: #9CA3AF;
}

.fiat-withdraw-badge {
  display: inline-flex;
  padding: 3px 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
}

.fiat-withdraw-badge--verified {
  background: rgb(74 222 128 / 20%);
  color: #34D399;
  border: 1px solid rgb(52 211 153 / 30%);
}

.fiat-withdraw-badge--otp {
  background: rgba(96, 165, 250, 0.12);
  color: #60A5FA;
}

.fiat-withdraw-bank-card__actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 12px;
}

.wf-select-btn {
  min-height: 34px;
  padding: 6px 14px;
  border-radius: 999px;
  border: 1px solid #D1AA67;
  background: transparent;
  color: #D1AA67;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}

.wf-select-btn:hover {
  background: rgba(209, 170, 103, 0.12);
}

.wf-select-btn.is-selected {
  background: #D1AA67;
  color: #1A1A1A;
}

.wf-select-btn--ghost {
  border-color: #efefef;
  color: #EAECEF;
}

.wf-select-btn--ghost:hover {
  border-color: #D1AA67;
  color: #D1AA67;
  background: transparent;
}

.fiat-withdraw-hide-btn {
  background: none;
  border: none;
  color: #fff;
  font-size: 12px;
  cursor: pointer;
  padding: 6px 4px;
  text-decoration: underline;
}

.fiat-withdraw-hide-btn:hover {
  color: #D1AA67;
}

.fiat-withdraw-link-btn {
  background: none;
  border: none;
  color: #D1AA67;
  font-size: 17px;
  font-weight: 600;
  cursor: pointer;
  padding: 0;
  margin-top: 4px;
  align-self: center;
  text-decoration: underline;
}

p.fiat-withdraw-help.right_alien {
  text-align: right;
  margin-top: -10px;
}

.fiat-withdraw-widget .df-submit-btn {
  margin-top: 0;
}

.fiat-withdraw-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 18px;
  width: 100%;
  margin-top: 8px;
}

.fiat-withdraw-actions .df-submit-btn {
  flex: 1 1 100%;
  width: 100%;
  min-height: 52px;
  margin-top: 0;
  border-radius: 30px;
}

.fiat-withdraw-actions .fiat-withdraw-btn {
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: calc(50% - 5px);
}

.fiat-withdraw-actions .df-submit-btn+.fiat-withdraw-btn:last-child {
  flex-basis: 100%;
}

.fiat-withdraw-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  /* min-height: 52px; */
  padding: 6px 0px;
  border-radius: 0px;
  border: none;
  background: none;
  font-weight: 600;
  color: #D1AA67;
  font-size: 17px;
  line-height: 1.2;
  white-space: nowrap;
  text-decoration: underline;
  cursor: pointer;
  transition: 0.2s;
}

.fiat-withdraw-btn:hover {
  border-color: #D1AA67;
  color: #D1AA67;
}

.fiat-withdraw-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.fiat-withdraw-alert {
  padding: 12px 16px;
  border-radius: 12px;
  margin-bottom: 12px;
  font-size: 14px;
}

.fiat-withdraw-alert--error {
  background: rgba(248, 113, 113, 0.12);
  border: 1px solid rgba(248, 113, 113, 0.35);
  color: #fca5a5;
}

.fiat-withdraw-alert--info {
  background: rgba(209, 170, 103, 0.1);
  border: 1px solid rgba(209, 170, 103, 0.35);
  color: #D1AA67;
}

.fiat-withdraw-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 120px;
  color: #707A8A;
}

.fiat-withdraw-widget p.subaccountbnk {
  font-size: 15px;
  color: #9CA3AF;
  margin-bottom: 10px;
  margin-top: -8px;
}

body.light_theme .fiat-withdraw-btn {
  color: #1E2329;
}

body.light_theme .fiat-withdraw-field input {
  background: rgb(0 0 0 / 10%);
  border: 1px solid #f3f3f3;
  color: #1E2329;
}

body.light_theme .fiat-withdraw-field label {
  color: #1a1a1a;
}

body.light_theme .fiat-withdraw-bank-card {
  background: rgb(0 0 0 / 5%);
  border-color: #EAECEF;
}

body.light_theme .wf-account-radio {
  border-color: rgba(0, 0, 0, 0.12);
  background: rgba(0, 0, 0, 0.02);
}

body.light_theme .fiat-withdraw-bank-card.selected .wf-account-radio {
  border-color: rgba(209, 170, 103, 0.4);
  background: rgba(209, 170, 103, 0.08);
}

body.light_theme .fiat-withdraw-bank-card__name {
  color: #1E2329;
}

body.light_theme button.fiat-withdraw-btn.adbankbtn {
  color: #0d0d0d;
}

body.light_theme .fiat-withdraw-help,
body.light_theme .fiat-withdraw-limit {
  color: #848E9C;
}

/* 
body.light_theme .wf-preview {
  background: #fff;
  border-color: #EAECEF;
} */

body.light_theme .wf-preview-row strong {
  color: #1E2329;
}

body.light_theme .fiat-withdraw-hide-btn {
  color: #848E9C;
}

.wf-limit-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 14px 16px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid #2B3139;
}

.wf-limit-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  font-size: 13px;
  color: #707A8A;
}

.wf-limit-row strong {
  color: #EAECEF;
  font-weight: 600;
  text-align: right;
}

.wf-limit-row--sub {
  font-size: 12px;
}

.wf-limit-row--sub strong {
  font-weight: 500;
  color: #D1AA67;
}

.wf-page {
  position: relative;
  min-height: 70vh;
}

.wf-page.is-loading .deposit-fiat-wrapper {
  opacity: 0;
  pointer-events: none;
}

.wf-page-glass {
  position: absolute;
  inset: 0;
  z-index: 30;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 80px 20px 40px;
  background: rgba(12, 14, 18, 0.38);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
}

.wf-page-glass__panel {
  width: min(420px, 100%);
  padding: 28px 24px;
  border-radius: 18px;
  border: 1px solid rgba(209, 170, 103, 0.28);
  background: rgba(24, 26, 32, 0.55);
  box-shadow: 0 18px 48px rgba(0, 0, 0, 0.28);
  text-align: center;
}

.wf-page-glass__panel p {
  margin: 14px 0 18px;
  color: #EAECEF;
  font-size: 14px;
}

.wf-page-glass__spinner {
  width: 36px;
  height: 36px;
  margin: 0 auto;
  border-radius: 50%;
  border: 3px solid rgba(209, 170, 103, 0.22);
  border-top-color: #D1AA67;
  animation: wf-spin 0.8s linear infinite;
}

.wf-page-glass__bones {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.wf-page-glass__bones span {
  display: block;
  height: 12px;
  border-radius: 999px;
  background: linear-gradient(90deg, rgba(209, 170, 103, 0.08), rgba(209, 170, 103, 0.28), rgba(209, 170, 103, 0.08));
  background-size: 200% 100%;
  animation: wf-glass-shimmer 1.4s ease-in-out infinite;
}

.wf-page-glass__bones span:nth-child(2) {
  width: 78%;
  margin: 0 auto;
}

.wf-page-glass__bones span:nth-child(3) {
  width: 56%;
  margin: 0 auto;
}

@keyframes wf-spin {
  to {
    transform: rotate(360deg);
  }
}

@keyframes wf-glass-shimmer {
  0% {
    background-position: 100% 0;
  }

  100% {
    background-position: -100% 0;
  }
}

.wf-amount-box {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 4px 8px 4px 16px;
  width: 100%;
  background: rgb(255 255 255 / 5%);
  border: 1px solid #5c5c5c;
  border-radius: 50px;
}

.wf-amount-box input,
.fiat-withdraw-field .wf-amount-box input {
  flex: 1 1;
  min-width: 0;
  border: none;
  background: transparent;
  padding: 12px 0;
  color: #fff;
  font-weight: 600;
  font-size: 17px;
  border-radius: 0;
}

.wf-amount-box input:focus {
  outline: none;
}

.wf-amount-box__side {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #D1D5DB;
  font-weight: 500;
  font-size: 15px;
  flex-shrink: 0;
}

.wf-max-btn {
  border: none;
  background: none;
  color: #9C6D1D;
  border-radius: 999px;
  padding: 6px 6px;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
}

.wf-max-btn:hover {
  background: rgba(209, 170, 103, 0.28);
}

.wf-verify-overlay {
  position: fixed;
  inset: 0;
  z-index: 10050;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(12, 14, 18, 0.55);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
}

.wf-verify-overlay--glass {
  background: rgba(12, 14, 18, 0.38);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
}

.wf-verify-modal {
  position: relative;
  width: min(440px, 100%);
  max-height: calc(100vh - 40px);
  overflow: auto;
  padding: 28px 24px 22px;
  border-radius: 16px;
  background: #181A20;
  border: 1px solid #2B3139;
  box-shadow: 0 18px 48px rgba(0, 0, 0, 0.35);
}

.wf-verify-modal--glass {
  border-radius: 18px;
  border: 1px solid rgba(209, 170, 103, 0.28);
  background: rgba(24, 26, 32, 0.62);
  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.4), 0 0 0 1px rgba(209, 170, 103, 0.08);
}

.wf-verify-close {
  position: absolute;
  top: 12px;
  right: 14px;
  width: 34px;
  height: 34px;
  padding: 0;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: #848E9C;
  font-size: 22px;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.wf-verify-close:hover {
  background: rgba(209, 170, 103, 0.12);
  color: #D1AA67;
}

.wf-verify-title {
  margin: 0 0 8px;
  font-size: 20px;
  color: #EAECEF;
}

.wf-verify-subtitle {
  margin: 0 0 20px;
  font-size: 13px;
  color: #848E9C;
  line-height: 1.5;
}

.wf-verify-field {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 16px;
}

.wf-verify-field label {
  font-size: 13px;
  color: #848E9C;
}

.wf-verify-field input,
.wf-verify-input-row input {
  width: 100%;
  padding: 12px 14px;
  border-radius: 10px;
  border: 1px solid #2B3139;
  background: #0B0E11;
  color: #EAECEF;
  font-size: 14px;
}

.wf-verify-field input:focus,
.wf-verify-input-row input:focus {
  outline: none;
  border-color: #D1AA67;
}

.wf-verify-input-row {
  display: flex;
  gap: 8px;
}

.wf-verify-input-row input {
  flex: 1 1;
}

.wf-verify-send {
  flex-shrink: 0;
  border: none;
  background: rgba(209, 170, 103, 0.16);
  color: #D1AA67;
  border-radius: 10px;
  padding: 0 14px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
}

.wf-verify-send:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.wf-verify-field-error {
  margin: 0;
  color: #f87171;
  font-size: 12px;
}

.wf-confirm-actions {
  display: flex;
  gap: 10px;
  margin-top: 8px;
}

.wf-confirm-actions .fiat-withdraw-btn,
.wf-confirm-remove-btn {
  flex: 1 1;
  min-height: 46px;
}

.wf-verify-modal--glass .wf-verify-title {
  color: #EAECEF;
}

.wf-verify-modal--glass .wf-verify-subtitle {
  color: #B7BDC6;
}

.wf-verify-modal--glass .fiat-withdraw-btn {
  background: transparent;
  border-color: rgba(209, 170, 103, 0.45);
  color: #EAECEF;
  border-radius: 50px;
}

.wf-verify-modal--glass .fiat-withdraw-btn:hover:not(:disabled) {
  border-color: #D1AA67;
  color: #D1AA67;
  background: rgba(209, 170, 103, 0.1);
}

.wf-confirm-remove-btn {
  border: none;
  border-radius: 30px;
  background: #f6465d;
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: 0.2s;
}

.wf-confirm-remove-btn:hover:not(:disabled) {
  background: #e03a50;
}

.wf-confirm-remove-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.wf-verify-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 14px;
  font-size: 12px;
  color: #848E9C;
}

.wf-verify-modal .df-submit-btn {
  margin-top: 8px;
}

body.light_theme .wf-limit-list {
  background: #F7F7F8;
  border-color: #EAECEF;
}

body.light_theme .wf-limit-row strong {
  color: #1E2329;
}

body.light_theme .wf-amount-box {
  background: rgb(0 0 0 / 5%);
  border-color: #EAECEF;
}

body.light_theme .wf-amount-box input,
body.light_theme .fiat-withdraw-field .wf-amount-box input {
  color: #1E2329;
  background: none;
  border: none;
}

body.light_theme .wf-amount-box__side {
  color: #1E2329;
}

body.light_theme .wf-verify-modal {
  background: #fff;
  border-color: #EAECEF;
}

body.light_theme .wf-verify-overlay--glass {
  background: rgba(255, 255, 255, 0.28);
}

body.light_theme .wf-verify-modal--glass {
  background: rgba(255, 255, 255, 0.62);
  border-color: rgba(209, 170, 103, 0.4);
}

body.light_theme .wf-verify-modal--glass .wf-verify-title {
  color: #1E2329;
}

body.light_theme .wf-verify-modal--glass .wf-verify-subtitle {
  color: #707A8A;
}

body.light_theme .wf-verify-modal--glass .fiat-withdraw-btn {
  background: transparent;
  border-color: rgba(209, 170, 103, 0.5);
  color: #1E2329;
}

body.light_theme .wf-verify-close:hover {
  background: rgba(209, 170, 103, 0.16);
  color: #B89353;
}

body.light_theme .wf-verify-title {
  color: #1E2329;
}

body.light_theme .wf-verify-field input,
body.light_theme .wf-verify-input-row input {
  background: #F7F7F8;
  border-color: #EAECEF;
  color: #1E2329;
}

body.light_theme .wf-select-btn--ghost {
  border-color: #565656;
  color: #1E2329;
}

body.light_theme .wf-page-glass {
  background: rgba(255, 255, 255, 0.35);
}

body.light_theme .wf-page-glass__panel {
  background: rgba(255, 255, 255, 0.62);
  border-color: rgba(209, 170, 103, 0.4);
}

body.light_theme .wf-page-glass__panel p {
  color: #1E2329;
}

@media (max-width: 767px) {

  .fiat-withdraw-field {
    margin-bottom: 4px;
  }

  .fiat-withdraw-actions .df-submit-btn {
    min-height: 42px;
  }

  .fiat-withdraw-btn {
    min-height: 42px;
    padding: 11px 20px;
    font-size: 13px;
  }

  .fiat-withdraw-field input,
  .fiat-withdraw-field select {
    font-size: 13px;
    padding: 12px 15px;
  }

  .fiat-withdraw-actions {
    gap: 8px;
  }

  .fiat-withdraw-bank-card__meta {
    font-size: 12px;
  }

  .fiat-withdraw-step-label {
    font-size: 16px;
  }

  .fiat-withdraw-widget p.subaccountbnk {
    font-size: 13px;
  }

  button.fiat-withdraw-btn.adbankbtn {
    min-height: 42px;
  }

}

@media screen and (max-width:580px) {

  .wf-account-radio {
    width: 32px;
    min-width: 32px;
    height: 32px;
  }

  .fiat-withdraw-help {
    font-size: 14px;
  }

}`, "",{"version":3,"sources":["webpack://./src/ui/Pages/WithdrawFiatPage/withdrawFiat.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,yBAAyB;EACzB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;;AAGA;;EAEE,sEAAsE;EACtE,iBAAiB;AACnB;;AAEA;;EAEE,mEAAmE;EACnE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,yBAAyB;EACzB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,SAAS;AACX;;AAEA;;EAEE,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,aAAa;AACf;;AAEA;;EAEE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,iCAAiC;EACjC,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,eAAe;AACjB;;AAEA;;;GAGG;;AAEH;EACE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,2CAA2C;EAC3C,sBAAsB;EACtB,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,uCAAuC;EACvC,qCAAqC;AACvC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,WAAW;EACX,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,cAAc;EACd,uCAAuC;AACzC;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,yBAAyB;EACzB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,eAAe;EACf,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAyB;EAAzB,cAAyB;EAAzB,2BAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,2CAA2C;EAC3C,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,iCAAiC;EACjC,+BAA+B;AACjC;;AAEA;EACE,sCAAsC;EACtC,qCAAqC;AACvC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;;;GAIG;;AAEH;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,kCAAkC;EAClC,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,2CAA2C;EAC3C,kCAAkC;EAClC,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,2CAA2C;EAC3C,yBAAyB;EACzB,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,oBAAoB;EACpB,mHAAmH;EACnH,0BAA0B;EAC1B,qDAAqD;AACvD;;AAEA;EACE,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,cAAc;AAChB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,yBAAyB;EACzB,WAAW;EACX,iCAAiC;EACjC,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;EAEE,SAAO;EACP,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kCAAkC;EAClC,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,8BAA8B;EAC9B,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,kCAAkC;EAClC,2BAA2B;EAC3B,mCAAmC;EACnC,+EAA+E;AACjF;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,qCAAqC;EACrC,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;;EAEE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,uCAAuC;EACvC,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;EACd,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;;IAEE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;AAEF;;AAEA;;EAEE;IACE,WAAW;IACX,eAAe;IACf,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;AAEF","sourcesContent":[".fiat-withdraw-widget {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.fiat-withdraw-step-label {\n  font-size: 20px;\n  font-weight: 700;\n  color: #fff;\n  margin-bottom: 0px;\n}\n\n.fiat-withdraw-help {\n  font-size: 15px;\n  color: #9CA3AF;\n  margin: 0 0 8px;\n  line-height: 1.5;\n}\n\n.fiat-withdraw-help--error {\n  color: #e45561;\n  font-weight: 600;\n}\n\n.wf-preview {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-bottom: 8px;\n}\n\n.wf-preview-row {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n  font-size: 15px;\n  color: #9CA3AF;\n}\n\n.wf-preview-row strong {\n  color: #fff;\n  font-weight: 600;\n}\n\n.wf-preview-row--net strong {\n  color: #D1AA67;\n}\n\n.wf-preview-hint {\n  margin: 8px 0 0;\n  font-size: 12px;\n  line-height: 1.45;\n  color: #848E9C;\n}\n\n.wf-verify-preview {\n  margin: 0 0 16px;\n}\n\n.wf-history-cancel-btn {\n  display: inline-flex;\n  margin-top: 8px;\n  min-height: 32px;\n  padding: 4px 12px;\n  border-radius: 999px;\n  border: 1px solid #fca5a5;\n  background: transparent;\n  color: #fca5a5;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.wf-history-cancel-btn:hover:not(:disabled) {\n  background: rgba(252, 165, 165, 0.12);\n}\n\n.wf-history-cancel-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n\n.wf-history-grid.df-deposit-history-head,\n.wf-history-grid.df-deposit-history-row {\n  grid-template-columns: 1.15fr 0.85fr 0.65fr 0.55fr 1.15fr 0.9fr 0.75fr;\n  min-width: 1040px;\n}\n\n.df-deposit-history-desktop--fiat.df-deposit-history-desktop--withdraw .df-deposit-history-head,\n.df-deposit-history-desktop--fiat.df-deposit-history-desktop--withdraw .df-deposit-history-row {\n  grid-template-columns: 1.15fr 0.8fr 0.6fr 0.5fr 1.1fr 0.85fr 1.15fr;\n  min-width: 1080px;\n}\n\n.df-deposit-history-desktop--withdraw .df-deposit-history-row-cell--action {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 8px;\n  white-space: nowrap;\n}\n\n.wf-history-review-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 32px;\n  padding: 4px 14px;\n  border-radius: 999px;\n  border: 1px solid #d1aa67;\n  background: transparent;\n  color: #d1aa67;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.wf-cancel-confirm-actions {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 12px;\n}\n\n.wf-cancel-confirm-keep,\n.wf-cancel-confirm-yes {\n  min-width: 160px;\n  height: 46px;\n  border-radius: 999px;\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.wf-cancel-confirm-keep {\n  border: 1px solid #2b3139;\n  background: transparent;\n  color: #eaecef;\n}\n\n.wf-cancel-confirm-keep:hover:not(:disabled) {\n  border-color: #d1aa67;\n  color: #d1aa67;\n}\n\n.wf-cancel-confirm-yes {\n  border: none;\n  background: #d1aa67;\n  color: #0c0d10;\n}\n\n.wf-cancel-confirm-yes:hover:not(:disabled) {\n  background: #c49a55;\n}\n\n.withdraw_hist_detail_modal.wf-fiat-detail-modal {\n  max-height: none;\n  overflow: visible;\n  padding: 18px 22px 16px;\n  width: 520px;\n}\n\n.wf-fiat-detail-modal .withdraw_hist_stepper {\n  margin-top: 12px;\n}\n\n.wf-fiat-detail-modal .withdraw_hist_step_note {\n  margin-top: 2px;\n  margin-bottom: 0;\n}\n\n.wf-fiat-detail-modal .withdraw_hist_rows {\n  margin-top: 12px;\n  padding-top: 10px;\n  gap: 8px;\n}\n\n.wf-fiat-detail-modal .withdraw_hist_row {\n  padding: 0;\n  min-height: 0;\n}\n\n.wf-fiat-detail-modal .withdraw_hist_row_label,\n.wf-fiat-detail-modal .withdraw_hist_row_value {\n  font-size: 13px;\n  line-height: 1.35;\n}\n\n.wf-fiat-detail-cancel {\n  width: 100%;\n  margin-top: 14px;\n}\n\n.wf-fiat-detail-help {\n  margin-top: 10px;\n  padding-left: 0;\n  text-align: center;\n  align-items: center;\n}\n\nbody.light_theme .wf-cancel-confirm-keep {\n  border-color: #eaecef;\n  color: #1e2329;\n}\n\n.df-deposit-history-desktop--withdraw .wf-history-cancel-btn,\n.wf-history-mobile-actions .wf-history-cancel-btn {\n  margin-top: 0;\n}\n\n.wf-history-mobile-actions {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.wf-history-pagination {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 16px;\n  padding: 18px 0 6px;\n}\n\n.wf-history-page-btn {\n  min-width: 92px;\n  padding: 8px 14px;\n  border-radius: 999px;\n  border: 1px solid #2B3139;\n  background: #181A20;\n  color: #EAECEF;\n  font-size: 13px;\n  cursor: pointer;\n}\n\n.wf-history-page-btn:hover:not(:disabled) {\n  border-color: #D1AA67;\n  color: #D1AA67;\n}\n\n.wf-history-page-btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.wf-history-page-info {\n  font-size: 13px;\n  color: #848E9C;\n}\n\nbody.light_theme .wf-history-page-btn {\n  background: #fff;\n  border-color: #EAECEF;\n  color: #1E2329;\n}\n\n.fiat-withdraw-limit {\n  font-size: 14px;\n  color: #9CA3AF;\n  padding-top: 6px;\n  text-align: right;\n}\n\n.fiat-withdraw-limit--error {\n  color: #e45561;\n  font-weight: 600;\n}\n\n.fiat-withdraw-field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin-bottom: 5px;\n}\n\n.fiat-withdraw-field label {\n  font-size: 14px;\n  font-weight: 500;\n  color: #9CA3AF;\n  margin-bottom: 5px;\n  display: block;\n}\n\n.fiat-withdraw-field-hint {\n  margin: 6px 0 0;\n  font-size: 13.65px;\n  line-height: 1.45;\n  color: #9CA3AF;\n}\n\nbody.light_theme .fiat-withdraw-step-label {\n  color: #222222;\n}\n\n.fiat-withdraw-field input,\n.fiat-withdraw-field select {\n  width: 100%;\n  color: #fff;\n  font-weight: 600;\n  font-size: 15px;\n  background: rgb(255 255 255 / 5%);\n  border: 1px solid #5c5c5c;\n  border-radius: 50px;\n  padding: 16px 20px;\n}\n\n.fiat-withdraw-field input:focus {\n  outline: none;\n  border-color: #D1AA67;\n}\n\n.fiat-withdraw-field input::placeholder {\n  color: #707A8A;\n}\n\n.fiat-withdraw-otp-row {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.fiat-withdraw-otp-row input {\n  flex: 1;\n  min-width: 140px;\n  letter-spacing: 4px;\n  text-align: center;\n  font-size: 18px;\n}\n\n.fiat-withdraw-resend {\n  background: none;\n  border: none;\n  color: #D1AA67;\n  font-size: 13px;\n  cursor: pointer;\n  padding: 0;\n}\n\n.fiat-withdraw-resend:disabled {\n  color: #707A8A;\n  cursor: not-allowed;\n}\n\n.fiat-withdraw-bank-card {\n  position: relative;\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  /* border: 1px solid #2B3139; */\n  border-radius: 14px;\n  padding: 18px;\n  margin-bottom: 10px;\n  cursor: pointer;\n  transition: 0.2s;\n  background: rgb(255 255 255 / 10%);\n}\n\n.fiat-withdraw-bank-card--static {\n  cursor: default;\n}\n\n/* .fiat-withdraw-bank-card:hover,\n.fiat-withdraw-bank-card.selected {\n  border-color: #D1AA67;\n} */\n\n.wf-account-radio-input {\n  position: absolute;\n  opacity: 0;\n  pointer-events: none;\n}\n\n.wf-account-radio {\n  flex-shrink: 0;\n  width: 44px;\n  min-width: 44px;\n  height: 44px;\n  margin-top: 2px;\n  border-radius: 50%;\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  box-sizing: border-box;\n  background: rgba(255, 255, 255, 0.03);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  transition: all 0.2s ease;\n}\n\n.wf-account-radio::before {\n  content: \"\";\n  position: absolute;\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  border: 2px solid #5E6673;\n  box-sizing: border-box;\n  transition: all 0.2s ease;\n}\n\n.wf-account-radio::after {\n  content: \"\";\n  position: absolute;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: transparent;\n  transition: all 0.2s ease;\n}\n\n.fiat-withdraw-bank-card.selected .wf-account-radio {\n  border-color: rgba(209, 170, 103, 0.35);\n  background: rgba(209, 170, 103, 0.08);\n}\n\n.fiat-withdraw-bank-card.selected .wf-account-radio::before {\n  border-color: #D1AA67;\n}\n\n.fiat-withdraw-bank-card.selected .wf-account-radio::after {\n  background: #D1AA67;\n}\n\nbutton.fiat-withdraw-btn.adbankbtn {\n  background: rgb(0 0 0 / 10%);\n  color: #fff;\n  text-decoration: none;\n  min-height: 52px;\n  border-radius: 50px;\n}\n\n.fiat-withdraw-field.verificationcode_block .fiat-withdraw-otp-row {\n  background: rgba(0, 0, 0, 0.10);\n  border: 1px solid #5c5c5c;\n  border-radius: 50px;\n  padding-right: 20px;\n}\n\n.fiat-withdraw-field.verificationcode_block .fiat-withdraw-otp-row input {\n  background: none;\n  border: none;\n  text-align: left;\n}\n\nbody.light_theme .fiat-withdraw-field.verificationcode_block .fiat-withdraw-otp-row {\n  background: rgb(0 0 0 / 5%);\n  border: 1px solid #e8e8e8;\n}\n\n.fiat-withdraw-bank-card__body {\n  flex: 1;\n  min-width: 0;\n}\n\n.fiat-withdraw-bank-card__top {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 6px;\n}\n\n.fiat-withdraw-bank-card__name {\n  font-size: 15px;\n  font-weight: 700;\n  color: #fff;\n}\n\n.fiat-withdraw-bank-card__meta {\n  font-size: 14px;\n  color: #9CA3AF;\n}\n\n.fiat-withdraw-badge {\n  display: inline-flex;\n  padding: 3px 8px;\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.fiat-withdraw-badge--verified {\n  background: rgb(74 222 128 / 20%);\n  color: #34D399;\n  border: 1px solid rgb(52 211 153 / 30%);\n}\n\n.fiat-withdraw-badge--otp {\n  background: rgba(96, 165, 250, 0.12);\n  color: #60A5FA;\n}\n\n.fiat-withdraw-bank-card__actions {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-top: 12px;\n}\n\n.wf-select-btn {\n  min-height: 34px;\n  padding: 6px 14px;\n  border-radius: 999px;\n  border: 1px solid #D1AA67;\n  background: transparent;\n  color: #D1AA67;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.wf-select-btn:hover {\n  background: rgba(209, 170, 103, 0.12);\n}\n\n.wf-select-btn.is-selected {\n  background: #D1AA67;\n  color: #1A1A1A;\n}\n\n.wf-select-btn--ghost {\n  border-color: #efefef;\n  color: #EAECEF;\n}\n\n.wf-select-btn--ghost:hover {\n  border-color: #D1AA67;\n  color: #D1AA67;\n  background: transparent;\n}\n\n.fiat-withdraw-hide-btn {\n  background: none;\n  border: none;\n  color: #fff;\n  font-size: 12px;\n  cursor: pointer;\n  padding: 6px 4px;\n  text-decoration: underline;\n}\n\n.fiat-withdraw-hide-btn:hover {\n  color: #D1AA67;\n}\n\n.fiat-withdraw-link-btn {\n  background: none;\n  border: none;\n  color: #D1AA67;\n  font-size: 17px;\n  font-weight: 600;\n  cursor: pointer;\n  padding: 0;\n  margin-top: 4px;\n  align-self: center;\n  text-decoration: underline;\n}\n\np.fiat-withdraw-help.right_alien {\n  text-align: right;\n  margin-top: -10px;\n}\n\n.fiat-withdraw-widget .df-submit-btn {\n  margin-top: 0;\n}\n\n.fiat-withdraw-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 18px;\n  width: 100%;\n  margin-top: 8px;\n}\n\n.fiat-withdraw-actions .df-submit-btn {\n  flex: 1 1 100%;\n  width: 100%;\n  min-height: 52px;\n  margin-top: 0;\n  border-radius: 30px;\n}\n\n.fiat-withdraw-actions .fiat-withdraw-btn {\n  flex: 1 1 calc(50% - 5px);\n}\n\n.fiat-withdraw-actions .df-submit-btn+.fiat-withdraw-btn:last-child {\n  flex-basis: 100%;\n}\n\n.fiat-withdraw-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n  /* min-height: 52px; */\n  padding: 6px 0px;\n  border-radius: 0px;\n  border: none;\n  background: none;\n  font-weight: 600;\n  color: #D1AA67;\n  font-size: 17px;\n  line-height: 1.2;\n  white-space: nowrap;\n  text-decoration: underline;\n  cursor: pointer;\n  transition: 0.2s;\n}\n\n.fiat-withdraw-btn:hover {\n  border-color: #D1AA67;\n  color: #D1AA67;\n}\n\n.fiat-withdraw-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.fiat-withdraw-alert {\n  padding: 12px 16px;\n  border-radius: 12px;\n  margin-bottom: 12px;\n  font-size: 14px;\n}\n\n.fiat-withdraw-alert--error {\n  background: rgba(248, 113, 113, 0.12);\n  border: 1px solid rgba(248, 113, 113, 0.35);\n  color: #fca5a5;\n}\n\n.fiat-withdraw-alert--info {\n  background: rgba(209, 170, 103, 0.1);\n  border: 1px solid rgba(209, 170, 103, 0.35);\n  color: #D1AA67;\n}\n\n.fiat-withdraw-loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 120px;\n  color: #707A8A;\n}\n\n.fiat-withdraw-widget p.subaccountbnk {\n  font-size: 15px;\n  color: #9CA3AF;\n  margin-bottom: 10px;\n  margin-top: -8px;\n}\n\nbody.light_theme .fiat-withdraw-btn {\n  color: #1E2329;\n}\n\nbody.light_theme .fiat-withdraw-field input {\n  background: rgb(0 0 0 / 10%);\n  border: 1px solid #f3f3f3;\n  color: #1E2329;\n}\n\nbody.light_theme .fiat-withdraw-field label {\n  color: #1a1a1a;\n}\n\nbody.light_theme .fiat-withdraw-bank-card {\n  background: rgb(0 0 0 / 5%);\n  border-color: #EAECEF;\n}\n\nbody.light_theme .wf-account-radio {\n  border-color: rgba(0, 0, 0, 0.12);\n  background: rgba(0, 0, 0, 0.02);\n}\n\nbody.light_theme .fiat-withdraw-bank-card.selected .wf-account-radio {\n  border-color: rgba(209, 170, 103, 0.4);\n  background: rgba(209, 170, 103, 0.08);\n}\n\nbody.light_theme .fiat-withdraw-bank-card__name {\n  color: #1E2329;\n}\n\nbody.light_theme button.fiat-withdraw-btn.adbankbtn {\n  color: #0d0d0d;\n}\n\nbody.light_theme .fiat-withdraw-help,\nbody.light_theme .fiat-withdraw-limit {\n  color: #848E9C;\n}\n\n/* \nbody.light_theme .wf-preview {\n  background: #fff;\n  border-color: #EAECEF;\n} */\n\nbody.light_theme .wf-preview-row strong {\n  color: #1E2329;\n}\n\nbody.light_theme .fiat-withdraw-hide-btn {\n  color: #848E9C;\n}\n\n.wf-limit-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding: 14px 16px;\n  border-radius: 12px;\n  background: rgba(255, 255, 255, 0.03);\n  border: 1px solid #2B3139;\n}\n\n.wf-limit-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n  font-size: 13px;\n  color: #707A8A;\n}\n\n.wf-limit-row strong {\n  color: #EAECEF;\n  font-weight: 600;\n  text-align: right;\n}\n\n.wf-limit-row--sub {\n  font-size: 12px;\n}\n\n.wf-limit-row--sub strong {\n  font-weight: 500;\n  color: #D1AA67;\n}\n\n.wf-page {\n  position: relative;\n  min-height: 70vh;\n}\n\n.wf-page.is-loading .deposit-fiat-wrapper {\n  opacity: 0;\n  pointer-events: none;\n}\n\n.wf-page-glass {\n  position: absolute;\n  inset: 0;\n  z-index: 30;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  padding: 80px 20px 40px;\n  background: rgba(12, 14, 18, 0.38);\n  backdrop-filter: blur(16px);\n  -webkit-backdrop-filter: blur(16px);\n}\n\n.wf-page-glass__panel {\n  width: min(420px, 100%);\n  padding: 28px 24px;\n  border-radius: 18px;\n  border: 1px solid rgba(209, 170, 103, 0.28);\n  background: rgba(24, 26, 32, 0.55);\n  box-shadow: 0 18px 48px rgba(0, 0, 0, 0.28);\n  text-align: center;\n}\n\n.wf-page-glass__panel p {\n  margin: 14px 0 18px;\n  color: #EAECEF;\n  font-size: 14px;\n}\n\n.wf-page-glass__spinner {\n  width: 36px;\n  height: 36px;\n  margin: 0 auto;\n  border-radius: 50%;\n  border: 3px solid rgba(209, 170, 103, 0.22);\n  border-top-color: #D1AA67;\n  animation: wf-spin 0.8s linear infinite;\n}\n\n.wf-page-glass__bones {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.wf-page-glass__bones span {\n  display: block;\n  height: 12px;\n  border-radius: 999px;\n  background: linear-gradient(90deg, rgba(209, 170, 103, 0.08), rgba(209, 170, 103, 0.28), rgba(209, 170, 103, 0.08));\n  background-size: 200% 100%;\n  animation: wf-glass-shimmer 1.4s ease-in-out infinite;\n}\n\n.wf-page-glass__bones span:nth-child(2) {\n  width: 78%;\n  margin: 0 auto;\n}\n\n.wf-page-glass__bones span:nth-child(3) {\n  width: 56%;\n  margin: 0 auto;\n}\n\n@keyframes wf-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes wf-glass-shimmer {\n  0% {\n    background-position: 100% 0;\n  }\n\n  100% {\n    background-position: -100% 0;\n  }\n}\n\n.wf-amount-box {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 4px 8px 4px 16px;\n  width: 100%;\n  background: rgb(255 255 255 / 5%);\n  border: 1px solid #5c5c5c;\n  border-radius: 50px;\n}\n\n.wf-amount-box input,\n.fiat-withdraw-field .wf-amount-box input {\n  flex: 1;\n  min-width: 0;\n  border: none;\n  background: transparent;\n  padding: 12px 0;\n  color: #fff;\n  font-weight: 600;\n  font-size: 17px;\n  border-radius: 0;\n}\n\n.wf-amount-box input:focus {\n  outline: none;\n}\n\n.wf-amount-box__side {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: #D1D5DB;\n  font-weight: 500;\n  font-size: 15px;\n  flex-shrink: 0;\n}\n\n.wf-max-btn {\n  border: none;\n  background: none;\n  color: #9C6D1D;\n  border-radius: 999px;\n  padding: 6px 6px;\n  font-size: 15px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.wf-max-btn:hover {\n  background: rgba(209, 170, 103, 0.28);\n}\n\n.wf-verify-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 10050;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  background: rgba(12, 14, 18, 0.55);\n  backdrop-filter: blur(12px);\n  -webkit-backdrop-filter: blur(12px);\n}\n\n.wf-verify-overlay--glass {\n  background: rgba(12, 14, 18, 0.38);\n  backdrop-filter: blur(16px);\n  -webkit-backdrop-filter: blur(16px);\n}\n\n.wf-verify-modal {\n  position: relative;\n  width: min(440px, 100%);\n  max-height: calc(100vh - 40px);\n  overflow: auto;\n  padding: 28px 24px 22px;\n  border-radius: 16px;\n  background: #181A20;\n  border: 1px solid #2B3139;\n  box-shadow: 0 18px 48px rgba(0, 0, 0, 0.35);\n}\n\n.wf-verify-modal--glass {\n  border-radius: 18px;\n  border: 1px solid rgba(209, 170, 103, 0.28);\n  background: rgba(24, 26, 32, 0.62);\n  backdrop-filter: blur(18px);\n  -webkit-backdrop-filter: blur(18px);\n  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.4), 0 0 0 1px rgba(209, 170, 103, 0.08);\n}\n\n.wf-verify-close {\n  position: absolute;\n  top: 12px;\n  right: 14px;\n  width: 34px;\n  height: 34px;\n  padding: 0;\n  border: none;\n  border-radius: 8px;\n  background: transparent;\n  color: #848E9C;\n  font-size: 22px;\n  line-height: 1;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.wf-verify-close:hover {\n  background: rgba(209, 170, 103, 0.12);\n  color: #D1AA67;\n}\n\n.wf-verify-title {\n  margin: 0 0 8px;\n  font-size: 20px;\n  color: #EAECEF;\n}\n\n.wf-verify-subtitle {\n  margin: 0 0 20px;\n  font-size: 13px;\n  color: #848E9C;\n  line-height: 1.5;\n}\n\n.wf-verify-field {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-bottom: 16px;\n}\n\n.wf-verify-field label {\n  font-size: 13px;\n  color: #848E9C;\n}\n\n.wf-verify-field input,\n.wf-verify-input-row input {\n  width: 100%;\n  padding: 12px 14px;\n  border-radius: 10px;\n  border: 1px solid #2B3139;\n  background: #0B0E11;\n  color: #EAECEF;\n  font-size: 14px;\n}\n\n.wf-verify-field input:focus,\n.wf-verify-input-row input:focus {\n  outline: none;\n  border-color: #D1AA67;\n}\n\n.wf-verify-input-row {\n  display: flex;\n  gap: 8px;\n}\n\n.wf-verify-input-row input {\n  flex: 1;\n}\n\n.wf-verify-send {\n  flex-shrink: 0;\n  border: none;\n  background: rgba(209, 170, 103, 0.16);\n  color: #D1AA67;\n  border-radius: 10px;\n  padding: 0 14px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.wf-verify-send:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.wf-verify-field-error {\n  margin: 0;\n  color: #f87171;\n  font-size: 12px;\n}\n\n.wf-confirm-actions {\n  display: flex;\n  gap: 10px;\n  margin-top: 8px;\n}\n\n.wf-confirm-actions .fiat-withdraw-btn,\n.wf-confirm-remove-btn {\n  flex: 1;\n  min-height: 46px;\n}\n\n.wf-verify-modal--glass .wf-verify-title {\n  color: #EAECEF;\n}\n\n.wf-verify-modal--glass .wf-verify-subtitle {\n  color: #B7BDC6;\n}\n\n.wf-verify-modal--glass .fiat-withdraw-btn {\n  background: transparent;\n  border-color: rgba(209, 170, 103, 0.45);\n  color: #EAECEF;\n  border-radius: 50px;\n}\n\n.wf-verify-modal--glass .fiat-withdraw-btn:hover:not(:disabled) {\n  border-color: #D1AA67;\n  color: #D1AA67;\n  background: rgba(209, 170, 103, 0.1);\n}\n\n.wf-confirm-remove-btn {\n  border: none;\n  border-radius: 30px;\n  background: #f6465d;\n  color: #fff;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: 0.2s;\n}\n\n.wf-confirm-remove-btn:hover:not(:disabled) {\n  background: #e03a50;\n}\n\n.wf-confirm-remove-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.wf-verify-footer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  margin-top: 14px;\n  font-size: 12px;\n  color: #848E9C;\n}\n\n.wf-verify-modal .df-submit-btn {\n  margin-top: 8px;\n}\n\nbody.light_theme .wf-limit-list {\n  background: #F7F7F8;\n  border-color: #EAECEF;\n}\n\nbody.light_theme .wf-limit-row strong {\n  color: #1E2329;\n}\n\nbody.light_theme .wf-amount-box {\n  background: rgb(0 0 0 / 5%);\n  border-color: #EAECEF;\n}\n\nbody.light_theme .wf-amount-box input,\nbody.light_theme .fiat-withdraw-field .wf-amount-box input {\n  color: #1E2329;\n  background: none;\n  border: none;\n}\n\nbody.light_theme .wf-amount-box__side {\n  color: #1E2329;\n}\n\nbody.light_theme .wf-verify-modal {\n  background: #fff;\n  border-color: #EAECEF;\n}\n\nbody.light_theme .wf-verify-overlay--glass {\n  background: rgba(255, 255, 255, 0.28);\n}\n\nbody.light_theme .wf-verify-modal--glass {\n  background: rgba(255, 255, 255, 0.62);\n  border-color: rgba(209, 170, 103, 0.4);\n}\n\nbody.light_theme .wf-verify-modal--glass .wf-verify-title {\n  color: #1E2329;\n}\n\nbody.light_theme .wf-verify-modal--glass .wf-verify-subtitle {\n  color: #707A8A;\n}\n\nbody.light_theme .wf-verify-modal--glass .fiat-withdraw-btn {\n  background: transparent;\n  border-color: rgba(209, 170, 103, 0.5);\n  color: #1E2329;\n}\n\nbody.light_theme .wf-verify-close:hover {\n  background: rgba(209, 170, 103, 0.16);\n  color: #B89353;\n}\n\nbody.light_theme .wf-verify-title {\n  color: #1E2329;\n}\n\nbody.light_theme .wf-verify-field input,\nbody.light_theme .wf-verify-input-row input {\n  background: #F7F7F8;\n  border-color: #EAECEF;\n  color: #1E2329;\n}\n\nbody.light_theme .wf-select-btn--ghost {\n  border-color: #565656;\n  color: #1E2329;\n}\n\nbody.light_theme .wf-page-glass {\n  background: rgba(255, 255, 255, 0.35);\n}\n\nbody.light_theme .wf-page-glass__panel {\n  background: rgba(255, 255, 255, 0.62);\n  border-color: rgba(209, 170, 103, 0.4);\n}\n\nbody.light_theme .wf-page-glass__panel p {\n  color: #1E2329;\n}\n\n@media (max-width: 767px) {\n\n  .fiat-withdraw-field {\n    margin-bottom: 4px;\n  }\n\n  .fiat-withdraw-actions .df-submit-btn {\n    min-height: 42px;\n  }\n\n  .fiat-withdraw-btn {\n    min-height: 42px;\n    padding: 11px 20px;\n    font-size: 13px;\n  }\n\n  .fiat-withdraw-field input,\n  .fiat-withdraw-field select {\n    font-size: 13px;\n    padding: 12px 15px;\n  }\n\n  .fiat-withdraw-actions {\n    gap: 8px;\n  }\n\n  .fiat-withdraw-bank-card__meta {\n    font-size: 12px;\n  }\n\n  .fiat-withdraw-step-label {\n    font-size: 16px;\n  }\n\n  .fiat-withdraw-widget p.subaccountbnk {\n    font-size: 13px;\n  }\n\n  button.fiat-withdraw-btn.adbankbtn {\n    min-height: 42px;\n  }\n\n}\n\n@media screen and (max-width:580px) {\n\n  .wf-account-radio {\n    width: 32px;\n    min-width: 32px;\n    height: 32px;\n  }\n\n  .fiat-withdraw-help {\n    font-size: 14px;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
